import { Environment } from '@environment/interfaces';
import { setEnvironmentVariables } from '@environment/utils/initialize-environment';
import { captureException } from '@sentry/browser';
import { withChromeRuntime } from '@shared/extension';
import { ExtensionCommunicationService } from '@shared/extension/services/extension-communication.service';
import { ServiceWorkerCommunicationService } from '@shared/extension/services/service-worker-communication.service';
import { initSentry, setSentryUser } from '@shared/sentry';
import { ONE_SECOND_MS } from '@shared/utils/constants';
import { getLearningApp } from '@shared/utils/utils';
import * as Handlers from './handlers';
import { ContentScriptStore } from './store';
import { attachCopilotInjectionScript, attachRequestInjectionScript, notifyDashboard, refreshCopilotScripts } from './utils';

const STORE_LOCAL_COPILOT_SCRIPT_DELAY = ONE_SECOND_MS * 2;

const environment: Environment = setEnvironmentVariables(process.env);

const extensionCommunicationService = new ExtensionCommunicationService();
const serviceWorkerCommunicationService = new ServiceWorkerCommunicationService();
const store = ContentScriptStore.getInstance();

// Content script logic

console.log(`Initializing content-script ${window.location.href}`);
const learningApp = getLearningApp(window.location.href);
const isDashboard = window.location.href.startsWith(environment.dashboardUrl);
const profileEmail = await serviceWorkerCommunicationService.getChromeProfileEmail();
store.setProfileEmail(profileEmail);
store.setLearningApp(learningApp);

// Only when we are on learning app page
if (store.learningApp$.value) {
  const errors: Error[] = [];
  Handlers.startHandlingSentryErrors(store, errors);

  // Init the injected scripts after the errors message listener is initialized
  const attachRequestInjectionScriptError: unknown = attachRequestInjectionScript();
  if (attachRequestInjectionScriptError) {
    errors.push(attachRequestInjectionScriptError as Error);
  }

  const backendUrl = await serviceWorkerCommunicationService.getBackendURL();
  store.setBackendUrl(backendUrl);

  initSentry(environment.enableSentry && !!environment.sentryAuthToken, environment, false, true);

  setSentryUser(store.profileEmail$.value);
  store.setSentryInitialized(true);

  errors.forEach((error: Error) => {
    captureException(error);
  });

  Handlers.handleWindowLoaded();

  setTimeout(() => {
    withChromeRuntime(async () => {
      await refreshCopilotScripts(serviceWorkerCommunicationService, store);
      attachCopilotInjectionScript();
    });
  }, STORE_LOCAL_COPILOT_SCRIPT_DELAY);

  Handlers.startHandlingSentryLogs();
}

if (store.learningApp$.value || isDashboard) {
  Handlers.startHandlingWindowMessages(extensionCommunicationService, serviceWorkerCommunicationService);
  Handlers.startHandlingContentScriptsUnload();
}

if (isDashboard) {
  notifyDashboard();
}

// For all pages
Handlers.handleDomContentLoaded();

console.log('Initialized content-script')
